import React from 'react';
import classNames from 'classnames';
import convert from 'htmr';
import Button from '../Button/Button';
import VideoPlayer from '../VideoPlayer/VideoPlayer';

const FeaturedContent = ({
  className = '',
  type = 'image',
  imageUrl = '',
  tag = '',
  title = '',
  text = '',
  ctas = [],
  videoPlayerProps = {},
}) => {
  const btnClass = className.includes('bg-blue-dark')
    ? 'btn btn--inverted'
    : 'btn btn--default';

  return (
    <div className={classNames('featured-content', className)}>
      <div className="featured-content__wrapper container">
        {type === 'image' && (
          <div
            className="featured-content__media featured-content__media--image"
            style={{ backgroundImage: `url(${imageUrl})` }}
          ></div>
        )}

        {type === 'video' && (
          <div className="featured-content__media featured-content__media--video">
            <VideoPlayer {...videoPlayerProps} />
          </div>
        )}

        <div className="featured-content__content">
          {tag && <div className="tag">{tag}</div>}
          {title && <div className="featured-content__title">{title}</div>}
          {text && (
            <div className="featured-content__text">{convert(text)}</div>
          )}
          {ctas.length > 0 && (
            <div className="featured-content__ctas">
              {ctas.map((cta, index) => (
                <Button
                  key={`featured-content-cta-${index}`}
                  {...cta}
                  className={btnClass}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeaturedContent;
